import CloseIcon from '../../../assets/icons/close.svg?react';
import { useDeleteAiModule } from '../../../hooks/queries/aiQueries';
import { useState } from 'react';
import dayjs from 'dayjs';
const AiModuleDeleteModal = ({onClose, target, onDeleteSuccess}) => {
  const deleteAiModule = useDeleteAiModule();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    setIsPending(true);
    try {
      await deleteAiModule.mutateAsync(target.AiModuleInfoSysId);
      onDeleteSuccess();
      onClose();
    } catch (error) {
      console.error('AI 모듈 삭제 실패:', error);
      alert('AI 모듈 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>AI 모듈 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">AI 모듈을 삭제하시겠습니까?</p>
          <table className='gray-table'>
            <tr>
              <th>모듈명</th>
              <td>{target.ModuleName}</td>
            </tr>
            <tr>
              <th>버전</th>
              <td>{target.Version || '-'}</td>
            </tr>
            <tr>
              <th>BaseUrl</th>
              <td>{target.BaseUrl || '-'}</td>
            </tr>
            <tr>
              <th>OriginAiAlgorithm</th>
              <td>{target.OriginAiAlgorithm || '-'}</td>
            </tr>
            <tr>
              <th>AiModelType</th>
              <td>{target.AiModelType || '-'}</td>
            </tr>
            <tr>
              <th>생성일시</th>
              <td>{target.CreatedDate || dayjs(target.CreatedDate).format('YYYY-MM-DD HH:mm:ss') || '-'}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-primary" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제 중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default AiModuleDeleteModal